import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import InlineLink from '@/components/InlineLink'

import { ReactComponent as Heart } from '@/svg/heart.svg'

import { copyrightYear, privacyPolicyLink, termOfUseLink } from './constants'
import Container from './style'

interface Props {
  style?: CSSProperties
  className?: string
  id?: string
}

function Footer({ id, className, style }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <section className="hidden-container">
        <InlineLink href={termOfUseLink} target="_blank" rel="noreferrer">
          Terms of Use
        </InlineLink>
        <InlineLink href={privacyPolicyLink} target="_blank" rel="noreferrer">
          Privacy Policy
        </InlineLink>
      </section>
      <section className="border">
        <div className="container">
          <section className="inner-container">
            <section className="license-container">
              <h1>
                ©{copyrightYear} <b>nDataThoth Limited</b> All Rights Reserved.
              </h1>
            </section>
            <section className="label-container">
              <section className="link-container">
                <InlineLink>
                  <a href={termOfUseLink} target="_blank" rel="noreferrer">
                    Terms of Use
                  </a>
                </InlineLink>
                <InlineLink>
                  <a href={privacyPolicyLink} target="_blank" rel="noreferrer">
                    Privacy Policy
                  </a>
                </InlineLink>
              </section>
              <h1>
                Made with <Heart /> in Bangkok
              </h1>
            </section>
          </section>
        </div>
      </section>
    </Container>
  )
}

Footer.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Footer.defaultProps = {
  className: '',
}

export default memo(Footer)
